import React from 'react';

import type { CheckboxChangeEvent } from 'antd/es/checkbox';

import { FlightSearchBarActionType } from '@domain/flight/context/flight/actions';

import useFlightSearchBar from '../../context/flight';
import { StyledCheckbox } from './styled';

const DirectFlight = () => {
  const { state, dispatch } = useFlightSearchBar();

  const handleChange = (event: CheckboxChangeEvent) => {
    dispatch({
      type: FlightSearchBarActionType.SET_IS_DIRECT_FLIGHT,
      payload: event.target.checked,
    });
  };

  return (
    <StyledCheckbox checked={state.isDirectFlight} onChange={handleChange}>
      Aktarmasız Uçuşlar
    </StyledCheckbox>
  );
};

export default DirectFlight;
